module.exports = __webpack_public_path__ + "static/media/7.Imported Water Pump.a142445e.jpg";